export default __webpack_public_path__ + "static/quote-video-4-static-bfc5097a5515404a7f8530d232506a73.png";